import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllMaquinasEquipItensUseCase } from "../../../presentation/useCases/read/get_all_maquinas_equip_itens_use_case";
import { MaquinaEquipItem } from "../../models/maquina_equip_item";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetAllMaquinasEquipItensUseCase
 */

export class GetAllMaquinasEquipItensUseCase
  extends BasePaginatedUseCase<MaquinaEquipItem>
  implements IGetAllMaquinasEquipItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllMaquinasEquipItens(
    idMaquinaEquip: number,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idMaquinaEquip === undefined) throw new Error("Falha ao obter id de máquina equipamento.");

    const response = await this.repository.getControledePatrimonioMaquinasEquipItensList(
      idMaquinaEquip,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
